var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVpcListVDisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "g54hpnfbva"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.023529 0 0 0 0 0.776471 0 0 0 0 0.615686 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)",
    filter: "url(#g54hpnfbva)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.75 12.25)",
    stroke: "#8793A3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 19.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0.8,
    x: 4.5,
    y: 6,
    width: 7.5,
    height: 7.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0.8,
    x: 6.375,
    y: 7.875,
    width: 3.75,
    height: 3.75,
    rx: 1.875
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7 16.875h-.4M13.7 2.625h-.4M3.2 16.875h-.4M3.2 2.625h-.4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVpcListVDisk);
export default __webpack_public_path__ + "static/media/ico-vpc-list-v-disk.3a1fca8a0f4819606fb90ece195ee193.svg";
export { ForwardRef as ReactComponent };